import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { active, EDButton, EDTypography, spacing } from "@trailblazer-game/ed-webkit";
import { useRouter } from "next/router";
import { EPage } from "../../../../helpers/constants";
import Box from "@mui/material/Box";
import { useParallax } from "react-scroll-parallax";
import { IWithLazyLoadProps, withLazyLoad } from "../../../../hooks/withLazyLoad";
import { forwardRef, memo } from "react";
import { theme } from "../../../Theme/Theme";

interface IHomeHeaderProps extends IWithLazyLoadProps {
  className?: string;
  seasonName: string;
}

const HomeHeader = memo(forwardRef(({ className, seasonName }: IHomeHeaderProps, ref) => {
  const router = useRouter();
  const { ref: dragonsRef } = useParallax<HTMLDivElement>({
    speed: 10,
    translateY: [ 0, -100, "easeInCirc" ],
    translateX: [ 50, 50 ]
  });

  const { ref: contentRef } = useParallax<HTMLDivElement>({
    speed: 5,
    translateY: [ 0, 50, "easeInCirc" ]
  });

  const handleNavigateToLeague = () => {
    router.push(EPage.LEAGUE_SOLO);
  }

  return <Stack className={className} alignItems={"center"} justifyContent={"center"} spacing={8} ref={ref}>
    <Box className={`dragons`} ref={dragonsRef}/>

    <Stack className={className} spacing={2} alignItems={"center"} justifyContent={"center"}
           sx={{ position: "relative", zIndex: 100 }} ref={contentRef}>
      <EDTypography className={"title"} variant="h1" align={"center"}>{seasonName} IS HERE</EDTypography>
      <EDTypography variant="body2" align={"center"}>Join the fight and Strive for Glory!</EDTypography>
      <EDButton onClick={handleNavigateToLeague} label={"Play Now"}/>
    </Stack>


    <video className={"video-player"} autoPlay muted loop>
      <source src="/home/alpha-out-now.webm" type="video/webm"/>
    </video>

  </Stack>;
}));

HomeHeader.displayName = "HomeHeader";

const HomeHeaderStyled = styled(HomeHeader)(() => ({
  paddingTop: spacing(8),
  overflow: "visible",
  maxWidth: "1440px",
  ".dragons": {
    position: "absolute",
    margin: "0 !important",
    top: `0`,
    left: `-50%`,
    width: "100%",
    maxWidth: "1920px",
    minHeight: "1600px",
    backgroundImage: "url(/home/dragons.webp)",
    backgroundSize: "cover",
    transform: "translateX(50%)",
    backgroundPosition: "50% 0",
    backgroundRepeat: "no-repeat",
  },
  ".title": {
    color: active("primary"),
    textShadow: `1px 1px 6px black`,
    maxWidth: "450px"
  },
  ".video-player": {
    aspectRatio: "16/9",
    width: "100%",
    borderRadius: 8,
    maxWidth: "600px"
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(0, 4),
    ".dragons": {
      minHeight: "100vh",
      width: "100vw"
    }
  }
}));

// Export
export default withLazyLoad(HomeHeaderStyled);